/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventupdatedwithimages3Inputs */

const en_eventupdatedwithimages3 = /** @type {(inputs: Eventupdatedwithimages3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event updated with images!`)
};

const de_eventupdatedwithimages3 = /** @type {(inputs: Eventupdatedwithimages3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event mit Bildern aktualisiert!`)
};

/**
* | output |
* | --- |
* | "Event updated with images!" |
*
* @param {Eventupdatedwithimages3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventupdatedwithimages3 = /** @type {((inputs?: Eventupdatedwithimages3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventupdatedwithimages3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventupdatedwithimages3(inputs)
	return de_eventupdatedwithimages3(inputs)
});
export { eventupdatedwithimages3 as "eventUpdatedWithImages" }